import { useAnimations, useGLTF } from '@react-three/drei'
import { useEffect } from 'react'
import { useControls } from 'leva'

export default function Fox()
{
    const fox = useGLTF('./Fox/glTF/Fox.gltf')
    const animations = useAnimations(fox.animations, fox.scene)

    const { animationName } = useControls({
        animationName: { options: animations.names }
    })

    useEffect(() => {
        fox.scene.traverse((child) => {
            if (child.isMesh) {
                child.castShadow = true
                child.receiveShadow = true
            }
        })
    }, [fox.scene])

    useEffect(() =>
    {
        const action = animations.actions[animationName]
        action
            .reset()
            .fadeIn(0.5)
            .play()

        // window.setTimeout(() =>
        // {
        //     animations.actions.Walk.play()
        //     animations.actions.Walk.crossFadeFrom(animations.actions.Run, 1)
        // }, 2000)

        return () =>
        {
            action.fadeOut(0.5) 
        }
    }, [ animationName ])

    return <primitive
        object={ fox.scene }
        scale={ 0.02 }
        position={ [ 0, -1, 0 ] }
        rotation-y={ 0.3 }
    />
}